import { useEffect, useState } from 'react'
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid'

const useLeadId = () => {
  const [leadId, setLeadId] = useState(() => {
    return localStorage.getItem('leadId') || ''
  })

  useEffect(() => {
    if (!leadId) {
      const generatedId = uuidv4()
      localStorage.setItem('leadId', generatedId)
      setLeadId(generatedId)
    }
  }, [leadId])

  return leadId
}

export default useLeadId
